export default function (http) {
    return {
        loadBlockInfo (data){
            return http.json({
                url: '/index/loadBlockInfo',
                data
            });
        },
        getTenant (data){
            return http.json({
                url: '/index/getTenant',
                data
            });
        },


        fillDetail (data){
            return http.json({
                url: '/index/fillDetail',
                data
            });
        },

        fillData  (data){
            return http.json({
                url: '/index/fillData',
                data
            });
        },

        khzb  (data){
            return http.json({
                url: '/index/khzb',
                data
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/configure/http/api/index.js